import { AcornsIcon } from '@acorns/icons'
import styled from 'styled-components'

import theme from 'theme'

import { whiteIconStyle } from '../styled-components'

// NavigationBar styled components

export const Container = styled.div<{ hasWhitePage?: boolean; backgroundColor?: string }>`
  position: relative;
  height: 66px;
  align-items: center;
  background-color: ${(props) => props.backgroundColor ?? theme.colors.white};
  display: flex;
  justify-content: center;
  padding: 0 16px;
  gap: 16px;
  ${(props) => (props.hasWhitePage ? 'box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.04);' : null)}

  @media (min-width: ${theme.breakpoints.sm + 1}px) {
    height: 80px;
    padding: 0 30px;
    gap: 30px;
  }
`

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 16px;

  @media (min-width: ${theme.breakpoints.sm + 1}px) {
    gap: 30px;
  }
`

export const StyledAcornsIcon = styled(AcornsIcon)`
  path {
    &[stroke] {
      stroke: ${theme.colors.slate};
    }
  }
`

export const WhiteIcon = styled(AcornsIcon)`
  ${whiteIconStyle}
`

// BackButton styled components

export const BackButton = styled.button<{ isShown: boolean }>`
  background: none;
  border: none;
  cursor: pointer;
  margin-right: auto;
  ${(props) => !props.isShown && 'visibility: hidden;'}
`
